import { Icon } from './Icon';

export type PageView = 'chart' | 'knowledge' | 'guide';

export function SiteHeader({ view, onChange }: { view: PageView; onChange: (view: PageView) => void }) {
  const navItems: Array<{ id: PageView; label: string }> = [
    { id: 'chart', label: '术数排盘' },
    { id: 'knowledge', label: '知识谱系' },
    { id: 'guide', label: '使用说明' }
  ];

  return (
    <header className="site-header">
      <div className="header-inner">
        <button className="brand" type="button" onClick={() => onChange('chart')} aria-label="返回易鉴首页">
          <span className="brand-seal" aria-hidden="true">易</span>
          <span>
            <strong>易鉴</strong>
            <small>传统术数研究工具</small>
          </span>
        </button>
        <nav aria-label="主导航" className="primary-nav">
          {navItems.map((item) => (
            <button key={item.id} type="button" className={view === item.id ? 'nav-item is-active' : 'nav-item'} aria-current={view === item.id ? 'page' : undefined} onClick={() => onChange(item.id)}>
              {item.label}
            </button>
          ))}
        </nav>
        <a className="source-link" href="https://github.com/fzgfeng4-cyber/yijing-atlas" target="_blank" rel="noreferrer" aria-label="在新窗口打开 GitHub 开源仓库">
          <Icon name="book" size={18} />
          <span>开源仓库</span>
        </a>
      </div>
    </header>
  );
}
